import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"display":"flex","flex-direction":"column","gap":"20px","max-width":"600px"} }
const _hoisted_2 = { style: {"display":"flex","gap":"15px"} }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Добавить коробку ")
const _hoisted_4 = { style: {"display":"flex","gap":"50px"} }
const _hoisted_5 = { style: {"display":"flex","flex-direction":"column","gap":"10px"} }
const _hoisted_6 = { style: {"display":"flex","flex-direction":"column","gap":"10px"} }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Подтвердить отправку")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_check = _resolveComponent("check")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_close = _resolveComponent("close")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_input, {
        "model-value": _ctx.modelInput,
        "onUpdate:model-value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modelInput) = $event)),
        disabled: _ctx.isFetchingGetOrder || _ctx.isFetchingSend,
        onKeyup: _withKeys(_ctx.validateAddBox, ["enter"])
      }, null, 8, ["model-value", "disabled", "onKeyup"]),
      _createVNode(_component_el_button, {
        loading: _ctx.isFetchingGetOrder,
        disabled: !_ctx.modelInput || _ctx.isFetchingSend,
        onClick: _ctx.validateAddBox
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["loading", "disabled", "onClick"])
    ]),
    _createElementVNode("div", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderWithBoxes, (el) => {
        return (_openBlock(), _createElementBlock("div", {
          key: el.id,
          style: {"border-top":"1px solid #8c939d","padding":"15px","display":"flex","gap":"10px","justify-content":"space-between"}
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", null, "Заказ: " + _toDisplayString(el.id), 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.getLocalizeDeliveryType(el.ordersDeliveries[0].type)), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(el.boxes, (item, key) => {
                return (_openBlock(), _createElementBlock("div", { key: key }, [
                  _createTextVNode(" Коробка " + _toDisplayString(item.num) + " - ", 1),
                  (item.active)
                    ? (_openBlock(), _createBlock(_component_el_icon, {
                        key: 0,
                        color: "green"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_check)
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createElementBlock("span", _hoisted_7, "?"))
                ]))
              }), 128))
            ])
          ]),
          _createVNode(_component_el_icon, { color: "red" }, {
            default: _withCtx(() => [
              _createVNode(_component_close, {
                style: {"width":"25px","height":"25px","cursor":"pointer"},
                onClick: ($event: any) => (_ctx.removeOrder(el.id))
              }, null, 8, ["onClick"])
            ]),
            _: 2
          }, 1024)
        ]))
      }), 128))
    ]),
    _createVNode(_component_el_button, {
      disabled: !_ctx.isConfirmMoving,
      loading: _ctx.isFetchingSend,
      onClick: _ctx.send
    }, {
      default: _withCtx(() => [
        _hoisted_8
      ]),
      _: 1
    }, 8, ["disabled", "loading", "onClick"])
  ]))
}